import { Component } from '@angular/core'
import { CurrentUserService } from 'app/shared/services/current-user.service'
import { ConfirmationService } from 'primeng/api'
import { ContentLayoutComponent } from '../../content-layout.component'
import { DividerModule } from 'primeng/divider';
import { NgIf, AsyncPipe } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { Ripple } from 'primeng/ripple';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-side-bar-profile',
    templateUrl: './side-bar-profile.component.html',
    styleUrls: ['./side-bar-profile.component.scss'],
    standalone: true,
    imports: [
        DividerModule,
        NgIf,
        ButtonDirective,
        Ripple,
        RouterLink,
        AsyncPipe,
    ],
})
export class SidebarProfileComponent {
  constructor(
    public contentLayout: ContentLayoutComponent,
    private confirmationService: ConfirmationService,
    private currentUserService: CurrentUserService
  ) {}

  onLogoutClick() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to logout?',
      header: 'Confirm',
      icon: 'fa-solid fa-arrow-right-from-bracket',
      accept: () => this.currentUserService.signOut(),
    })
  }
}
